import React, { useState } from "react";
import { Cascader, Descriptions, Input, Modal, message } from "antd";
import { httpClient } from "../services/http.service";
import { repairsCode, displayRender } from "./DownloadRFQOverride";

// Quarantines an ACTIVE unit with a reason and the issue discovered (same details as the SCSR page),
// then lets the caller add it to the RFQ.
export function QuarantineUnitModal({ unit, rfqNumber, onClose, onQuarantined }) {
  const [comment, setComment] = useState("");
  const [issues, setIssues] = useState([]);
  const [saving, setSaving] = useState(false);

  const issueOptions = (repairsCode[unit?.model] || []).map((group) => ({
    value: group.name,
    label: group.name,
    children: group.codes?.map((code) => ({
      value: `${code.code} - ${code.text}`,
      label: `${code.code} - ${code.text}`,
    })),
  }));

  const submit = () => {
    if (!comment.trim()) return message.warning(`Please enter the reason you want to quarantine ${unit?.serialNumber}.`);

    setSaving(true);
    httpClient
      .put(`/api/v1/scsr/${unit?._id}/quarantined`, {
        comment: comment.trim(),
        lastInspectionDetails: issues.map((issue) => issue[1]).join(", "),
      })
      .then(() => {
        setSaving(false);
        onQuarantined({ ...unit, status: "quarantined" });
      })
      .catch((err) => {
        setSaving(false);
        message.error(`Failed to quarantine ${unit?.serialNumber} (${err?.response?.data?.message || err?.response?.data || err?.message})`);
      });
  };

  return (
    <Modal
      open={!!unit}
      width={700}
      title={`${unit?.serialNumber} is ${unit?.status?.toUpperCase()}`}
      okText="Quarantine and add to RFQ"
      cancelText="Cancel"
      onOk={submit}
      onCancel={onClose}
      confirmLoading={saving}
      destroyOnClose
    >
      <p>
        This unit is not quarantined. Pressing <strong>Quarantine and add to RFQ</strong> will quarantine it now and add
        it to this RFQ{rfqNumber ? ` (${rfqNumber})` : ""}.
      </p>
      <Descriptions size="small" column={3} style={{ marginBottom: 8 }}>
        <Descriptions.Item label="Serial Number">{unit?.serialNumber}</Descriptions.Item>
        <Descriptions.Item label="Mine Number">{unit?.mineNumber || "-"}</Descriptions.Item>
        <Descriptions.Item label="Model">{unit?.model || "-"}</Descriptions.Item>
      </Descriptions>
      <Cascader
        style={{ width: "100%", marginBottom: 10 }}
        multiple
        placeholder="Issue Discovered"
        options={issueOptions}
        expandTrigger="hover"
        displayRender={displayRender}
        value={issues}
        onChange={(value) => setIssues(value)}
      />
      <Input.TextArea
        rows={3}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder={`Please enter the reason you want to quarantine ${unit?.serialNumber}`}
      />
    </Modal>
  );
}
